import React from "react"
import {createBrowserRouter, RouterProvider} from "react-router-dom"
import {ErrorBoundary, Provider} from "@rollbar/react"

import RequireAuth from "@auth/hoc/RequireAuth"
import {AuthProvider} from "@auth/context"

import {mainRoutes} from "./routes"

const router = createBrowserRouter(mainRoutes, {
    basename: "/app"
})

const FallbackUI = () => <div>Oops, something went wrong</div>

export default () =>
    <Provider config={{endpoint: `${window.location.origin}/api/rollbar`}}>
        <ErrorBoundary fallbackUI={FallbackUI}>
            <AuthProvider>
                <RequireAuth>
                    <RouterProvider router={router}/>
                </RequireAuth>
            </AuthProvider>
        </ErrorBoundary>
    </Provider>

